var map = {
	"./banhanguytin/1-2.png": "b3bc",
	"./cacung/1-2.png": "7f04",
	"./chuyencan/1-2.png": "cf40",
	"./daigiadataha/1-2.png": "84a2",
	"./duhanhgia/1-2.png": "b818",
	"./thanhsanma/1-2.png": "46ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "893b";